function parseDateToken(token) {
    const trimmedToken = token.trim();

    const dmyMatch = trimmedToken.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (dmyMatch) {
        const day = Number(dmyMatch[1]);
        const monthIndex = Number(dmyMatch[2]) - 1;
        const year = Number(dmyMatch[3]);
        const parsed = new Date(year, monthIndex, day);

        if (
            parsed.getFullYear() === year &&
            parsed.getMonth() === monthIndex &&
            parsed.getDate() === day
        ) {
            return parsed;
        }
    }

    const parsed = new Date(trimmedToken);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function extractDatesFromString(dateString) {
    if (!dateString) {
        return [];
    }

    const tokenMatches = dateString.match(/\d{1,2}-\d{1,2}-\d{4}|\d{4}-\d{2}-\d{2}/g) || [];
    const parsedTokens = tokenMatches
        .map((token) => parseDateToken(token))
        .filter(Boolean);

    if (parsedTokens.length > 0) {
        return parsedTokens;
    }

    const fallbackDate = parseDateToken(dateString);
    return fallbackDate ? [fallbackDate] : [];
}

function getDateSortValue(item) {
    const parsedDates = extractDatesFromString(item.date);

    if (parsedDates.length === 0) {
        return Number.NEGATIVE_INFINITY;
    }

    return parsedDates[parsedDates.length - 1].getTime();
}

export function getNewestFirstItems(items) {
    return [...items].sort((first, second) => getDateSortValue(second) - getDateSortValue(first));
}

export function getMostRecentItem(items) {
    return getNewestFirstItems(items)[0] ?? null;
}
